import { render, staticRenderFns } from "./GiftPanel.vue?vue&type=template&id=27750ede&scoped=true&"
import script from "./GiftPanel.vue?vue&type=script&lang=js&"
export * from "./GiftPanel.vue?vue&type=script&lang=js&"
import style0 from "./GiftPanel.vue?vue&type=style&index=0&id=27750ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27750ede",
  null
  
)

export default component.exports